import { interval, Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable()
export class AutoRefreshService {

    private readonly destroyRef = inject(DestroyRef);

    private refreshInterval: number;
    private $refreshSubject = new Subject<void>();
    private $stopTimer = new Subject<void>();
    private $timeLeftSubject = new Subject<number>();

    startAutoRefresh(minutes: number) {
        this.stopAutoRefresh();

        this.refreshInterval = minutes;

        const intervalSecond = minutes * 60; // Convert minutes to seconds
        let counter = intervalSecond;

        interval(1000)
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                map(() => counter--),
                takeUntil(this.$stopTimer)
            )
            .subscribe((timeLeft) => {
                this.$timeLeftSubject.next(timeLeft);
                if (timeLeft === 0) {
                    this.$refreshSubject.next();
                    counter = intervalSecond;
                }
            });
    }

    resetAutoRefresh() {
        this.startAutoRefresh(this.refreshInterval);
    }

    stopAutoRefresh() {
        this.$stopTimer.next();
    }

    getRefreshObservable(): Observable<void> {
        return this.$refreshSubject.asObservable();
    }

    getTimeLeftObservable(displayInMinute?: boolean): Observable<string> {

        const formatTimeElement = (time: number): string => {
            return time < 10 ? `0${time}` : `${time}`;
        }

        return this.$timeLeftSubject.asObservable().pipe(
            map((seconds) => {
                if (displayInMinute) {
                    const minutes = Math.floor(seconds / 60);
                    const remainingSeconds = seconds % 60;
                    const formattedMinutes = formatTimeElement(minutes);
                    const formattedSeconds = formatTimeElement(remainingSeconds);
                    return `${formattedMinutes}:${formattedSeconds}`;
                }
                return seconds?.toString();
            })
        );
    }

}
